export default {
  faqTitle: 'Türk Nippon Sigorta Hakkında Merak Edilen Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  products: {
    title: 'Türk Nippon Sigorta Ürünleri',
    buttons: [
      {
        id: 1,
        title: 'TRAFİK SİGORTASI',
        class: 'company--btn--icons fas fa-car fa-2x mr-2',
        path: 'TurkNipponSigortaCompulsoryTraffic'
      },
      {
        id: 2,
        title: 'KASKO SİGORTASI',
        class: 'company--btn--icons fas fa-car-crash fa-2x mr-2',
        path: 'TurkNipponSigortaMotorInsurance'
      },
      {
        id: 3,
        title: 'DASK SİGORTA',
        class: 'company--btn--icons fas fa-laptop-house fa-2x mr-2',
        path: 'TurkNipponSigortaDaskInsurance'
      },
      {
        id: 4,
        title: 'KONUT SİGORTASI',
        class: 'company--btn--icons fas fa-house-damage fa-2x mr-2',
        path: 'TurkNipponSigortaHomeInsurance'
      },
      {
        id: 5,
        title: 'İŞYERİ SİGORTASI',
        class: 'company--btn--icons fas fa-building  fa-2x mr-2',
        path: 'TurkNipponSigortaCompanyInsurance'
      },
      {
        id: 6,
        title: 'FERDİ KAZA SİGORTASI',
        class: 'company--btn--icons fas fa-user-injured fa-2x mr-2',
        path: 'TurkNipponSigortaPersonalAccident'
      },
      {
        id: 7,
        title: 'NAKLİYAT SİGORTASI',
        class: 'company--btn--icons fas fa-luggage-cart fa-2x mr-2',
        path: 'TurkNipponSigortaTransportation'
      },
      {
        id: 8,
        title: 'İKİNCİ EL ARAÇ GARANTİ SİGORTASI',
        class: 'company--btn--icons fas fa-handshake fa-2x mr-2',
        path: 'TurkNipponSigortaSecondhandGuaranteeInsurance'
      },

      {
        id: 9,
        title: 'TAMAMLAYICI SAĞLIK SİGORTASI',
        class: 'company--btn--icons fas fa-briefcase-medical fa-2x mr-2',
        path: 'TurkNipponSigortaComplementaryHealth'
      },

      {
        id: 10,
        title: 'SEYAHAT SAĞLIK SİGORTASI',
        class: 'company--btn--icons fas fa-umbrella-beach fa-2x mr-2',
        path: 'TurkNipponSigortaTravelInsurance'
      },
      {
        id: 11,
        title: 'DOĞUM SİGORTASI',
        class: 'company--btn--icons fas fa-birthday-cake fa-2x mr-2',
        path: 'TurkNipponSigortaBirthInsurance'
      }
    ]
  },
  introContent: {
    title: 'Türk Nippon Sigorta Hakkında',
    content: [
      {
        paragraph:
          'Türk Nippon Sigorta Anonim Şirketi 1991 yılında, 25 milyar TL sermayesiyle Türkiye Kalkınma Bankası ve Japonya’daki birinci sigorta firması Nippon Fire & Marine ortaklıklarıyla kurulmuştur. Sümerbank tarafından 1998 yılında, % 85,22 hisse oranını satılması ile ortaklık yapısında büyük değişiklik olmuştur.'
      },
      {
        paragraph:
          '2000 senesinde %96.24 hisse ile Tasarrufu Mevduat Sigorta Fonuna devrolan Türk Nippon Sigorta, 2001 senesinde HNS Grup tarafından satın alınmıştır. '
      },
      {
        paragraph:
          '2008 tarihine kadar HNS Grup iştirakleri arasında kalan sigorta şirketi, sonrasında Harel Grup tarafından alınmıştır. 2008 senesinden itibaren Harel Grup gücünüde arkasına alarak, sigortacılık hizmetlerini sürdürmektedir.'
      },
      {
        paragraph:
          'Müşterilerine, iş ortaklarına ve çalışanlarına değer yaratarak kaliteli hizmet verme vizyonu ile ilerleyen Türk Nippon Sigorta’dan en uygun fiyatları alabilirsiniz.'
      }
    ]
  },
  questions: [
    {
      title: 'Türk Nippon Sigorta Ürün Çeşitleri Nelerdir?',
      content: [
        {
          paragraph:
            'Türk Nippon Sigorta Alokasko’nun anlaşmalı olduğu sigorta şirketlerindendir. Şirketimiz bünyesinde size özel teklif verebileceğimiz sigorta bazı ürünler;',
          subList: [
            'Zorunlu Trafik Sigortası',

            'Araç Kasko Sigortası',

            'DASK (Zorunlu Deprem Sigortası)',

            'Konut Sigortası',

            'İşyeri Sigortası',

            'Ferdi Kaza Sigortası',

            'Nakliyat Sigortası',

            'Tamamlayıcı Sağlık Sigortası',

            'Seyahat Sağlık Sigortası',

            'İkinci El Araç Garanti Sigortası'
          ]
        },
        {
          paragraph:
            'Türk Nippon Sigorta’dan teklif almak isteyen tüm müşterilerimiz <strong><em><u>alokasko.com</u></em></strong> sayfamızdan minimum fiyat avantajları ile avantajlı tekliflere ulaşabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türk Nippon Sigorta Zorunlu Trafik Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Türk Nippon Sigorta, trafik sigortası paketinde, motorlu aracın kullanılması esnasında üçüncü kişilerin ölümü, yaralaması veya bir varlığın zarar görmesine sebebiyet vermesinden kaynaklanan Karayolları Trafik Kanununa göre,  kullanıcı için belirlenen zorunlu trafik sigortası limitleri kapsamında meydana gelen zararları karşılar.',
          subList: null
        },
        {
          paragraph:
            '2021 yılında Devlet Hazine Müsteşarlığı tarafından belirlenen trafik sigortası limitleri;',
          subList: [
            'Araç Başı Maddi Tazminat: 43.000 TL',
            'Kaza Başı Maddi Tazminat: 86.000 TL',
            'Kişi Başı Sağlık Giderleri Tazminatı: 430.000 TL',
            'Kaza Başı Sağlık Giderleri Tazminatı: 2.150.000 TL',
            'Kişi Başı Sakatlanma ve Ölüm Tazminatı: 430.000 TL',
            'Kaza Başı Sakatlanma ve Ölüm Tazminatı: 2.150.000 TL'
          ]
        },
        {
          paragraph:
            'Aracınızın trafik sigortası tekliflerini <strong><em><u>alokasko.com</u></em></strong> sigorta danışmanlarından en uygun ve avantajlı şekilde talep edebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türk Nippon Sigorta Araç Kasko Sigortası Nedir?',
      content: [
        {
          paragraph: 'Türk Nippon Sigorta;',
          subList: ['Geniş Kasko', 'Mavi Kasko (Dar Kasko)', 'Gülümseten Kasko']
        },
        {
          paragraph: 'Paketleri ile farklı avantajlar ve fiyatlar sunar.',
          subList: [
            'Geniş kapsamlı sunulan kasko sigortası isminden de anlaşılacağı üzere tam kapsamlı koruma sağlar. ',
            'Mavi Kasko Sigortası ise sadece teminat kapsamındaki durumlardan kaynaklanan ve zarar kapsamında pert olan araçlar için geçerlidir.',
            'Gülümseten Kasko ise sadece otomobil kullanım tarzı araçlar için geçerli olmaktadır.'
          ]
        },
        {
          paragraph:
            '<strong>Türk Nippon Kasko Fiyatlarını</strong> değerlendirmek için teklif almanız yeterlidir. Teklif formunu doldurmanız durumunda karşılaştırmalı teminatlar tarafınıza iletilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türk Nippon Sigorta DASK – Zorunlu Deprem Sigortası Nedir?',
      content: [
        {
          paragraph: 'Deprem sigortası ile:',
          subList: [
            'Depremden kaynaklanan maddi zararlar,',
            'Deprem sonucu infilak,',
            'Deprem sonucu yangın,',
            'Deprem sonucu yer kayması,',
            'Deprem sonucu sel-su baskını,',
            'Deprem sonucu tsunami kaynaklı durumlar güvence altına alınmaktadır.'
          ]
        },
        {
          paragraph: 'DASK Zorunlu Deprem Sigortası kapsamında olan alanlar: ',
          subList: [
            'Ana duvarlar ',
            'Asansörler ',
            'Bacalar ',
            'Bağımsız bölümleri ayıran ortak duvarlar ',
            'Bahçe duvarları İstinat duvarları ',
            'Çatılar ',
            'Koridorlar ',
            'Merdivenler ',
            'Sahanlıklar ',
            'Tavan ve tabanlar ',
            'Temeller ',
            'Yapının yukarıdakilerle benzer tamamlayıcı bölümleri.'
          ]
        },
        {
          paragraph: 'DASK primleri:',
          subList: [
            'Konutların yapı tarzı,',
            'Binanızın yaşı,',
            'Kullanım tarzı,',
            'Konutun net metrekare ölçüsü baz alınarak hesaplanır.'
          ]
        },
        {
          paragraph:
            'Zorunlu deprem sigortası prim hesaplaması 5 risk bölgesi ve 3 farklı yapı tarzına göre belirleniş olan 15 farklı tarife fiyatı üzerinden yapılır.',
          subList: null
        },
        {
          paragraph:
            'En uygun DASK fiyatlarına ulaşmak için teklif al formunu doldurabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türk Nippon Sigorta Konut Sigortası Nedir?',
      content: [
        {
          paragraph:
            '<strong>Türk Nippon Konut Sigortası</strong> ile hem eviniz hem de değerli eşyalarınız güvence altında. İster ev sahibi olun ister kiracı, konut paket sigorta ile güvencenizi hemen başlatabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            '<strong>Konut sigortası</strong> hırsızlıktan cam kırılmasına, kira kaybından doğal afetlere kadar birçok riski güvence altına almaktadır. Üstelik sunulan asistans hizmetleri ile avantajlarını katlamaktadır.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Türk Nippon Asistans Hizmetleri:</u></em></strong>',
          subList: [
            'Tesisat işleri',
            'Elektrik işleri',
            'Cam işleri',
            'Anahtar işleri',
            'Doktor veya ambulans gönderilmesi',
            'Uzman hemşire veya refakatçi gönderilmesi',
            'Otel hizmeti',
            'Güvenlik şirketi',
            'Acil mesajların iletilmesi',
            'Profesyonel ev hizmetleri organizasyonu',
            'Bilgi ve organizasyon servisini kapsar.'
          ]
        },
        {
          paragraph:
            '**Türk Nippon Konut Sigortası avantajlarını değerlendirmek için şimdi teklif alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türk Nippon Sigorta İş Yeri Sigortası Nedir?',
      content: [
        {
          paragraph:
            'İş yeri sigortası, olası riskleri güvence altına almaktadır. Teminat kapsamı geniş olan Türk Nippon İş Yeri Sigortası ile güvencenizi başlatarak hem çalışanlarınızı hem de iş yerinizi tam kapsamlı koruma altına alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Ana teminatların yanı sıra sunulan ek teminatlar ile öne çıkan iş yeri poliçesinin ekstra sunulan asistans hizmetleri de bulunmaktadır. Tesisat işleri - Elektrik işleri - Anahtar işleri - Cam işleri - Güvenlik şirketi bu hizmetler kapsamındadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Türk Nippon Sigorta Ferdi Kaza Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Sigorta kapsamına alınan sigortalının başına gelebilecek kaza durumlarına karşı teminat sağlayarak, olası durumlarda poliçe kapsamı doğrultusunda ödeme yapar.',
          subList: null
        },
        {
          paragraph:
            'Beklenmedik ve ani gelişen hayati kazaları güvence altına almak için <strong><em>Türk Nippon Ferdi Kaza Sigortası</em></strong> yaptırabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Türk Nippon Ferdi Kaza Sigortası Teminatları:</u></em></strong>',
          subList: [
            'Kaza Sonu Daimi Sakatlık Teminatı',
            'Kaza Sonucu Vefat Teminatı'
          ]
        },
        {
          paragraph:
            '<strong><em><u>Türk Nippon Ferdi Kaza Sigortası İsteğe Bağlı Teminatlar:</u></em></strong>',
          subList: [
            'Kaza Sonucu Tedavi Masrafları Teminatı',
            'Gündelik Tazminat Teminatı'
          ]
        },
        {
          paragraph:
            '** Teminat ve limitleri detaylı karşılaştırmak için teklif alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türk Nippon Sigorta İkinci El Araç Garanti Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Almış olduğunuz ikinci el aracınızda oluşacak olan mekanik arızalarınızın onarımını yaptırabileceğiniz sigorta ürünüdür. Kasko poliçelerinde, aracın mekanik arızaları teminat kapsamında değildir. Fakat bu poliçede teminat kapsamındaki tüm arızalarınızın onarımını yaptırabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Türk Nippon Sigorta İkinci El Araç Garanti Sigortası sadece Türkiye sınırları içerisinde geçerli olmaktadır.',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Türk Nippon Sigorta İkinci El Araç Garanti Sigortası Kapsamı:</u></em></strong>',
          subList: [
            'Motor',
            'Diferansiyel ve Şaft',
            'Şanzıman',
            'Elektrik',
            'Yap Sızdırmalık ve Contalar',
            'Ana Ünite Kaplamaları'
          ]
        },
        {
          paragraph:
            '**Teminat kapsamında değerlendirilen arızaların ödemesi Türk Nippon’dan onay alınarak yapılmalıdır. Aksi takdirde onaysız işlemler sigorta şirketi tarafından ödenmeyecektir.',
          subList: null
        },
        {
          paragraph:
            '** Poliçe kapsamında olan araçlar tamir ve ilgili servis işlerini yetkili servislerde yaptırabilir. Periyodik bakımın ise belirtilen sürelerde yaptırılması gerekmektedir. Bakımı yaptırmayan araçlar garanti kapsamından düşer.',
          subList: null
        }
      ]
    },
    {
      title: 'Türk Nippon Sigorta Nakliyat Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Türk Nippon Sigorta işyerinizi güvenceye aldığı gibi taşımacılık sektöründe faaliyet gösteren müşterileri için de taşıdığı ürünleri teminat altına almaktadır. ',
          subList: null
        },
        {
          paragraph:
            'Taşıma, teslim sürecinde oluşabilecek her türlü karşılaşılabileceğiniz hasarların sorumluluğunu almaktadır. Sadece ülkemiz sınırları içinde değil, uluslararası taşımacılık faaliyetlerinizde de sigorta paketlerinden faydalanabilirsiniz. ',
          subList: null
        },
        {
          paragraph:
            'Değişen ekonomi ve günümüz şartlarında oluşabilecek her türlü kaza ve hasar sonucu alabileceğiniz zararlardan korunmak için <strong><em><u>alokasko.com</u></em></strong> uzmanlarından bilgi alıp, güvenli bir şekilde hizmetinize devam edebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türk Nippon Sigorta Tamamlayıcı Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Türk Nippon Sigorta Tamamlayıcı Sağlık Sigortası, özel hastanelere fark ücreti ödemeden kaliteli hizmet almanızı sağlar. Sadece fiyatlardan tasarruf etmekle kalmaz aynı zamanda sağlığınızı da tam kapsamlı güvence altına almış olursunuz.',
          subList: null
        },
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası poliçeleri 1 yıllık yapılır ve isteğe bağlı yenileme ile avantajlardan yararlanmaya devam edilir.',
          subList: null
        },
        {
          paragraph:
            'Yatarak tedavi ve ayakta tedavi seçeneğinin yanı sıra avantajları ile öne çıkan Türk Nippon Tamamlayıcı Sağlık Sigortası kapsamında;',
          subList: [
            'Diş Tasarruf Planı',
            'Diyetisyen Danışmanlık Tasarruf Planı',
            'Psikolojik Danışmanlık Tasarruf Planı',
            'Dar Check-Up Paket Planı Seçimli',
            'Kritik Hastalıklar Teminatı (Seçimli) hizmetlerinden de faydalanama şansınız vardır.'
          ]
        },
        {
          paragraph:
            '** Türk Nippon tamamlayıcı sağlık sigortasını <strong><em><u>0- 59 yaş aralığında</u></em></strong> ve <strong><em><u>SGK kapsamında</u></em></strong> olan kişiler satın alabilir. ',
          subList: null
        }
      ]
    },
    {
      title: 'Türk Nippon Sigorta Seyahat Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Türk Nippon Sigorta Seyahat Sağlık Sigortası, yurtiçi ve yurt dışı seyahatlerinizde oluşabilecek her türlü kaza , yaralanma, tedavi giderleri , hastalık nedeni ile nakil, vefat eden sigortalının nakli , kaybolan bagajların bulunması , bulunan bagajların sigortalıya ulaşımı ve yolculuk sırasında oluşabilecek tüm zorluklara karşı güvence altına alan sigorta ürünüdür. Bu ürün aynı zamanda , ülkelerine girişte vize koyan tüm ülkelerin , vize kontrol işlemi sırasında istedikleri zorunlu bir sigorta ürünüdür. Gidilecek ülke ve kalınacak gün sayısına bağlı olarak poliçe süresi ve poliçe primi belirlenir. Peşin ve taksitli ödeme seçenekleri mevcuttur. Seyahate çıkmadan önce alokasko.com sigorta',
          subList: null
        }
      ]
    },
    {
      title: 'Türk Nippon Sigorta Poliçe Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Türk Nippon Sigorta poliçe sorgulaması yapmak isteyen sigortalılar sigorta şirketinin resmi web sitesini ziyaret edebilir ya da sigorta acentesini arayabilir. (Mevcut sigorta poliçe sorgulaması için)',
          subList: null
        }
      ]
    },
    {
      title: 'Türk Nippon Sigorta Hasar Dosya Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Türk Nippon Sigorta hasar dosya sorgulaması yapmak isteyen sigortalılar sigorta şirketinin resmi web sitesini ziyaret edebilir. “<strong><em><u>Online İşlemler</u></em></strong>” menüsünde yer alan “<strong><em><u>Hasar Dosya Sorgulama</u></em></strong>” butonuna tıklayarak, T.C. Kimlik Numarasını ve hasar dosya numarasını girerek sorgulama işlemini gerçekleştirebilir.',
          subList: null
        },
        {
          paragraph:
            'Sigorta poliçenizi <strong><em><u>alokasko.com</u></em></strong> üzerinden satın aldıysanız, tüm hasar işlemlerinizi hasar uzmanlarımız takip edecektir. Hasar dosya sorgulamanız hakkında sigorta danışmanınızdan bilgi almak isterseniz <strong><em><u>0216 371 67 77</u></em></strong> numaralı iletişim hattımızı arayabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türk Nippon Sigorta Poliçe Fiyatı Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Türk Nippon Sigorta poliçe fiyatı almak için yapmanız gereken tek şey <strong><em><u>alokasko.com</u></em></strong> uzman sigorta danışmanlarından destek almaktır. ',
          subList: null
        },
        {
          paragraph:
            'Hangi branşta olursa olsun, poliçenizde olmasını istediğiniz teminatları bildirmeniz durumunda sizlere en avantajlı fiyat tekliflerini sunuyor olacağız. İhtiyaç duyduğunuz teminatlara şimdi sahip olmak için teklif alabilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
